import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Modal } from '@/components/ui/Modal'
import { LoginForm } from '@/components/auth/LoginForm'
import { RegisterForm } from '@/components/auth/RegisterForm'

export function useAuthModalBackgroundLocation() {
  const location = useLocation()
  const state = location.state as { backgroundLocation?: unknown } | null

  return useMemo(() => {
    const pathname = location.pathname
    const isAuthModal = pathname === '/auth/login' || pathname === '/auth/register'

    if (state?.backgroundLocation) return { isAuthModal, backgroundLocation: state.backgroundLocation }
    if (!isAuthModal) return { isAuthModal, backgroundLocation: null }

    // Direct visit to /auth/* should still look like a modal on top of home.
    return { isAuthModal, backgroundLocation: { ...location, pathname: '/' } }
  }, [location, state?.backgroundLocation])
}

export function AuthModalRoutes({ backgroundLocation }: { backgroundLocation: unknown }) {
  const location = useLocation()
  const navigate = useNavigate()

  const close = () => {
    const state = location.state as { backgroundLocation?: unknown } | null
    if (state?.backgroundLocation) {
      navigate(-1)
      return
    }
    navigate('/', { replace: true })
  }

  if (location.pathname === '/auth/login') {
    return (
      <Modal open onClose={close} title="Login" size="md">
        <LoginForm backgroundLocation={backgroundLocation} />
      </Modal>
    )
  }

  if (location.pathname === '/auth/register') {
    return (
      <Modal open onClose={close} title="Register" size="md">
        <RegisterForm backgroundLocation={backgroundLocation} />
      </Modal>
    )
  }

  return null
}

